import React from 'react';
import {CircularProgress} from 'material-ui/Progress';
import {greyShade} from '../../../../../../../../src/styles/colorCharts';

export function CircularIndeterminate() {
    return (
        <div className="manage-margin">
            {/*<CircularProgress/>*/}
            {/*<CircularProgress size={50}/>*/}
            {/*<CircularProgress color="secondary"/>*/}
            <CircularProgress color="inherit" size={50}/>
        </div>
    );
}

export function CircularIndeterminate2() {
    return (
        <div className="manage-margin">
            <CircularProgress color="inherit"/>
        </div>
    );

}

export function CircularIndeterminate3() {
    return (
        <div className="manage-margin">
            <CircularProgress color="inherit" size={120}/>
        </div>
    );

}



// WEBPACK FOOTER //
// ./app/routes/components/routes/progressbar/circular/indeterminate/CircularIndeterminate.js